import moment from 'moment';

export const isFutureDate = (date: Date | null) =>
  moment(date).isAfter(moment());

export const isYoungerThan18 = (date: Date | null) =>
  moment().diff(moment(date), 'years') < 18;
